import { render, staticRenderFns } from "./ReportesProyeccion.vue?vue&type=template&id=0f306148&"
import script from "./ReportesProyeccion.vue?vue&type=script&lang=js&"
export * from "./ReportesProyeccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports